import React, {useMemo} from 'react';
import {Link, useRouteMatch} from 'react-router-dom';
import {listRules, useRulesData} from './data-api';
import {makeLabel, Alert} from "./shared";
import config from '../../shared/config';

function RuleLink(props) {
	let {url} = useRouteMatch();
	let {rule} = props;
	let {ruleId} = rule;
	let displayName = rule.displayName || ruleId;
	return <div><Link to={`${url}/rules/${ruleId}`}>{displayName}</Link></div>;
}

function parseFilterOptions(config, filter) {
	let {filters = []} = config;
	for (let [f, options] of filters) {
		([f] = makeLabel(f));
		if (f === filter) {
			return new Map(Array.from(options).map((o) => makeLabel(o)));
		}
	}
	return new Map();
}

function FilterDisplay(props) {
	let {rule, filter} = props;
	let cfg = config.get('ServiceConfiguration');
	let options = useMemo(() => parseFilterOptions(cfg, filter), [cfg, filter]);
	let value = rule[filter];
	if (value) {
		if (Array.isArray(value)) {
			let values = Array.from(value)
				.map(v => options.get(v))
				.filter(v => Boolean(v));

			if (values.length) {
				return <span>{values.join(', ')}</span>;
			}
		}

		value = options.get(value);
		if (value) {
			return <span>{value}</span>
		}
	}
	return <span>-</span>;
}

function parseFilters(cfg) {
	let {filters = []} = cfg;
	return Array.from(filters).map(([f]) => makeLabel(f));
}

function RuleDisplay(props) {
	let {rule, filters} = props;
	return (
		<tr>
			<td><RuleLink rule={rule}/></td>
			{
				filters.map(
					([id]) => {
						return (
							<td key={`filter-display-${id}`}>
								<FilterDisplay rule={rule} filter={id}/>
							</td>
						)
					}
				)
			}
		</tr>
	)
}

function RulesList() {
	let [loading, rules] = useRulesData(listRules);
	let cfg = config.get('ServiceConfiguration');
	let filters = useMemo(() => parseFilters(cfg), [cfg]);

	if (loading) {
		return (
			<Alert icon="folder-o">Loading the Rules from the Central Configuration Service</Alert>
		);
	}

	if (rules === null) {
		return (
			<Alert icon="sun-o">
				There are currently no Ingress Control Rules configured.<br/>
				You may want to create one.
			</Alert>
		);
	}

	rules = Object.entries(rules).map(([ruleId, rule]) => Object.assign({ruleId}, rule));

	let ths = [
		<th key='display-name'>Display Name</th>
	];
	for (let [id, label] of filters) {
		ths.push(<th key={`filter-th-${id}`}>{label}</th>);
	}

	return (
		<>
			<h2>Registered Rules</h2>
			<table className="table table-striped">
				<thead>
					<tr>
						{ths}
					</tr>
				</thead>
				<tbody>
					{
						rules.map(
							(rule) => <RuleDisplay key={rule.ruleId} rule={rule} filters={filters}/>
						)
					}
				</tbody>
			</table>
		</>
	);
}

export default RulesList;